import React, {useEffect, useState} from "react";
import style from "../../assets/css/static-page.module.scss";
import {Box, Grid} from "@mui/system";
import {
  Breadcrumbs,
  Button,
  Chip,
  FormHelperText,
  Typography,
} from "@mui/material";
import {Link} from "react-router-dom";
import About1 from "../../assets/img/static/about1.png";
import About2 from "../../assets/img/static/about2.png";
import {Facebook, Instagram, LinkedIn} from "@mui/icons-material";
import jwBlockShapeImg from "../../assets/img/static/jwBlockShape.svg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import UserImg from "../../assets/img/static/user.jpg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {Navigation, Keyboard} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";

import {Card, CardContent, Avatar, IconButton, Stack} from "@mui/material";

const teamMembers = [
  {
    id: 1,
    name: "Janak Dave",
    title: "CEO",
    // description:
    // "Janak Dave has over 30 years of experience in the jewelry industry. Mr. Dave began his career in 1987 with Prominent International Inc., headquartered in the diamond district, in New York City. Mr. Dave was founder and President of Prominent International Inc., specializing...",
    description_full:
      "Janak Dave has over 30 years of experience in the jewelry industry. Mr. Dave began his career in 1987 with Prominent International Inc., headquartered in the Diamond District in New York City. Mr. Dave was founder and President of Prominent International Inc., specializing in trading Precious Color Gemstones and Diamonds. Mr. Dave successfully launched Surya Capital, LLC in 2005 a partnership fund with focus on trading diamonds and jewelry from various opportunities. Throughout his career, Mr. Dave has held various leadership positions. He has been a Principal of Prominent International Inc., and Surya Capital, LLC since inception. Mr. Dave has an extensive background in the Diamond and Jewelry industry, and has been trading Diamonds and Jewelry for the past 30 years. Mr. Dave is a Graduate Gemologist from the Gemological Institute of America(GIA). The merger of Associated International Brokers, Inc and Surya Capital, LLC is an outgrowth of his long-term and in-depth involvement in the jewelry industry.",

    image: UserImg,
    socials: ["facebook", "instagram", "linkedin"],
    hover:
      "Janak Dave has over 30 years of experience in the jewelry industry. Mr. Dave began his career in 1987 with Prominent International Inc., headquartered in the Diamond District in New York City. Mr. Dave was founder and President of Prominent International Inc., specializing in trading Precious Color Gemstones and Diamonds. Mr. Dave successfully launched Surya Capital, LLC in 2005 a partnership fund with focus on trading diamonds and jewelry from various opportunities. Throughout his career, Mr. Dave has held various leadership positions. He has been a Principal of Prominent International Inc., and Surya Capital, LLC since inception. Mr. Dave has an extensive background in the Diamond and Jewelry industry, and has been trading Diamonds and Jewelry for the past 30 years. Mr. Dave is a Graduate Gemologist from the Gemological Institute of America(GIA). The merger of Associated International Brokers, Inc and Surya Capital, LLC is an outgrowth of his long-term and in-depth involvement in the jewelry industry.",
  },
  {
    id: 2,
    name: "Roopang Shukla",
    title: "Director",
    // description:
    // "Roopang Shukla has been working as a marketing professional in jewelry industry since 1998. He has deep and extensive knowledge of diamonds, diamond jewelry and other precious and semi-precious gem stones. Since 2007 he has been...",
    description_full:
      "Roopang Shukla has been working as a marketing professional in the jewelry industry since 1998. He has deep and extensive knowledge of diamonds, diamond jewelry and other precious and semi-precious gemstones. Since 2007, he has been associated with Surya Capital LLC and has been involved in various closeout deals of diamonds, diamond jewelry, and other gemstones. Roopang Shukla is also a New York State licensed property and casualty insurance agent and broker. He has in-depth knowledge of various casualty and property insurance issues such as Jewelers Block Policies, Commercial Package Property, Business Owners Policy and other related topics. With over 18 years of experience in the jewelry industry, he is able to identify and address the unique needs and risks faced by the business-owners community in the jewelry industry.",
    image: UserImg,
    socials: ["facebook", "instagram", "linkedin"],
    hover:
      "Roopang Shukla has been working as a marketing professional in the jewelry industry since 1998. He has deep and extensive knowledge of diamonds, diamond jewelry and other precious and semi-precious gemstones. Since 2007, he has been associated with Surya Capital LLC and has been involved in various closeout deals of diamonds, diamond jewelry, and other gemstones. Roopang Shukla is also a New York State licensed property and casualty insurance agent and broker. He has in-depth knowledge of various casualty and property insurance issues such as Jewelers Block Policies, Commercial Package Property, Business Owners Policy and other related topics. With over 18 years of experience in the jewelry industry, he is able to identify and address the unique needs and risks faced by the business-owners community in the jewelry industry.",
  },

  {
    id: 3,
    name: "Setu Sanghani",
    title: "Insurance Specialist",
    // description:
    // "Setu Sanghani has over 24 years of experience in Jewelers Block and Fine Art insurance, combining expertise in client relations, sales, and risk management She has successfully managed insurance portfolios from design to implementation...",
    description_full:
      "Setu Sanghani has over 24 years of experience in Jewelers Block and Fine Art insurance, combining expertise in client relations, sales, and risk management. She has successfully managed insurance portfolios from design to implementation, strategically allocating risk while enhancing client security. She is known for her proactive approach to problem-solving and her ability to navigate complex insurance challenges with precision. Setu is highly skilled in relationship management and client satisfaction, consistently delivering tailored solutions to meet unique client needs. Her background also includes broader experience across other areas of Property and Casualty insurance.",
    image: UserImg,
    socials: [],
    hover:
      "Setu Sanghani has over 24 years of experience in Jewelers Block and Fine Art insurance, combining expertise in client relations, sales, and risk management. She has successfully managed insurance portfolios from design to implementation, strategically allocating risk while enhancing client security. She is known for her proactive approach to problem-solving and her ability to navigate complex insurance challenges with precision. Setu is highly skilled in relationship management and client satisfaction, consistently delivering tailored solutions to meet unique client needs. Her background also includes broader experience across other areas of Property and Casualty insurance.",
  },
  {
    id: 4,
    name: "Kush Dave",
    title: "Product Manager",
    // description:
    // "Kush Dave is a STEM graduate from Cornell University with 10 years of experience in development, including 5 years in product management and insurance systems. His technical background allows him to design and implement solutions that align...",
    description_full:
      "Kush Dave is a STEM graduate from Cornell University with 10 years of experience in development, including 5 years focused on product management and engineering of insurance systems. His technical background allows him to design and implement solutions that align with the evolving needs of the insurance industry, with a focus on innovation, scalability, and operational efficiency. Kush also has hands-on experience in Jewelers Block operations. He has worked closely on assembling proposals, drafting policies, and consulting with underwriters and policyholders during the claims process. His ability to bridge the gap between technology and insurance operations makes him a valuable asset in delivering efficient, client-focused solutions.",
    image: UserImg,
    socials: [],
    hover:
      "Kush Dave is a STEM graduate from Cornell University with 10 years of experience in development, including 5 years focused on product management and engineering of insurance systems. His technical background allows him to design and implement solutions that align with the evolving needs of the insurance industry, with a focus on innovation, scalability, and operational efficiency. Kush also has hands-on experience in Jewelers Block operations. He has worked closely on assembling proposals, drafting policies, and consulting with underwriters and policyholders during the claims process. His ability to bridge the gap between technology and insurance operations makes him a valuable asset in delivering efficient, client-focused solutions.",
  },
];

const iconMap = {
  facebook: <Facebook />,
  instagram: <Instagram />,
  linkedin: <LinkedIn />,
};

const AboutUs = () => {
  const [open, setOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(1);

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    const nativeInputs = document.querySelectorAll(".MuiSelect-nativeInput");
    nativeInputs.forEach((input) => {
      input.setAttribute("aria-label", "Age 33");
    });
  }, []);

  const handleClickOpen = (id) => {
    setSelectedMember(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {/* <section className={style.contactSection}>
        <Grid container spacing={2}>
          <Grid size={{xs: 12}} sx={{m: 2}}>
            <div className={style.staticPageBanner}>
              <div>
                <span> ABOUT Us </span>
                <h1> Let’s Know Us </h1>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" to="/">
                    Home
                  </Link>
                  <Typography sx={{color: "text.primary"}}>About us</Typography>
                </Breadcrumbs>
              </div>
            </div>
          </Grid>
        </Grid>
      </section> */}

      <section className={style.jeleryBlockSection}>
        <Grid
          container
          spacing={2}
          className="customeContainer"
          justifyContent="center"
          alignItems="center"
        >
          <Grid size={{xs: 12, lg: 6}}>
            <div className={style.jwBlockImg}>
              <img src={About1} alt="expertise-img" />

              <div className={style.jwBlockShapeLeft}>
                <img src={jwBlockShapeImg} alt="shape1" />
              </div>

              <div className={style.jwBlockShapeRight}>
                <img src={jwBlockShapeImg} alt="shape2" />
              </div>
            </div>
          </Grid>
          <Grid size={{xs: 12, lg: 6}}>
            <div className={style.jwBlocktextRight}>
              <h2>About Us</h2>
              <p>
                Associated International Brokers, Inc is a premier brokerage
                specializing in Jewelers Block Insurance, offering tailored risk
                solutions for jewelers, wholesalers, manufacturers, retailers,
                art galleries, and pawnshops worldwide. With a deep-rooted
                legacy in the jewelry trade and decades of expertise in
                specialty insurance, we provide comprehensive coverage for
                high-value assets, trade shows, global shipments, and client
                entrustments.
              </p>
            </div>
          </Grid>

          <Grid size={{xs: 12, lg: 6}} className={style.ourTeam_Order2}>
            <div className={style.jwBlocktextRight}>
              <h2>Our Story</h2>
              <p>
                Our legacy in the jewelry insurance industry dates back to 1983,
                when the late Elan Manham founded Associated International
                Brokers, Inc (AIB), building a trusted reputation for
                specialized coverage and client service. In 2016, Janak Dave, a
                fourth-generation jeweler with over 40 years of industry
                experience, Merged with AIB. Janak’s background extends beyond
                jewelry, having successfully managed a distressed hedge fund
                focused on the jewelry sector, giving him a unique perspective
                on risk and asset protection. Recognizing the power of combining
                expertise and market reach, AIB merged in 2021, uniting decades
                of specialized knowledge and creating a global brokerage with
                deep roots in both the jewelry trade and high-value asset
                insurance. Today, AIB continues to serve clients worldwide with
                tailored insurance solutions, backed by a legacy of integrity,
                industry insight, and personalized service.
              </p>
            </div>
          </Grid>

          <Grid size={{xs: 12, lg: 6}} className={style.ourTeam_Order1}>
            <div className={style.jwBlockImg}>
              <img src={About2} alt="expertise-img" />
              <div className={style.jwBlockShapeRight}>
                <img src={jwBlockShapeImg} alt="shape2" />
              </div>
            </div>
          </Grid>
        </Grid>
      </section>

      <section className={style.abotContentSection}>
        <Grid
          container
          maxWidth="sm"
          spacing={2}
          className="customeContainer"
          justifyContent="center"
          alignItems="center"
        >
          <Grid size={{xs: 12, lg: 8}}>
            <div className={style.abotContentMian}>
              <p>
                Today, we serve clients in over 20 countries, with a strong
                presence in Asia, Africa, Europe, and North America, while
                offering comprehensive worldwide coverage. Our team consists of
                seasoned brokers with deep industry knowledge, ensuring that
                each client receives customized policies, competitive pricing,
                and unmatched claims support. Whether securing coverage for a
                single retail location, an international jewelry operation, or a
                valuable art collection, Associated International Brokers, Inc
                is the trusted partner for protecting the world’s most precious
                assets.
              </p>
            </div>
          </Grid>
        </Grid>
      </section>

      <section className={style.abotOurTeamSection}>
        <Grid
          container
          maxWidth="sm"
          spacing={2}
          className="customeContainer"
          justifyContent="center"
          alignItems="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.ourTeamTitle}>
              <h2>Meet Our Team</h2>
              {/* <p>For more information contact</p> */}
            </div>
          </Grid>

          <Grid container spacing={4} justifyContent="center">
            <Grid size={{xs: 12, xl: 12}}>
              <Swiper
                loop={false}
                slidesPerView={3}
                slidesPerGroup={1}
                navigation={true}
                pagination={{clickable: true}}
                // mousewheel
                keyboard
                modules={[Navigation, Keyboard]}
                className="MeetTeamSlider"
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                  },
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1199: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1442: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
              >
                {teamMembers.map((member, index) => (
                  <SwiperSlide key={index}>
                    <Card sx={{borderRadius: 4}} className={style.ourTeamBox}>
                      <Stack
                        spacing={2}
                        alignItems="center"
                        direction={{xs: "column", sm: "column", lg: "row"}}
                      >
                        <Avatar
                          variant="rounded"
                          alt={member.name}
                          src={member.image}
                          sx={{width: 150, height: 150}}
                        />

                        <Box>
                          <Typography variant="h6">{member.name}</Typography>
                          <Chip
                            aria-label="social-icon"
                            label={member.title}
                            size="small"
                            sx={{
                              mt: 0.5,
                              backgroundColor: "#E5F3FA",
                              color: "#004F71",
                              fontWeight: 500,
                              fontSize: "0.75rem",
                              padding: "15px 10px",
                              marginBottom: "5px",
                            }}
                          />
                          {Array.isArray(member.socials) &&
                            member.socials.length > 0 && (
                              <Stack
                                direction="row"
                                spacing={1}
                                mt={1}
                                className={style.TeamSocialIcon}
                              >
                                {member.socials.map((social) => (
                                  <IconButton
                                    aria-label="social-icon"
                                    key={social}
                                    className={style.ourTeamIcon}
                                    size="small"
                                    style={{padding: "17px"}}
                                    sx={{
                                      backgroundColor: "#004F71",
                                      color: "#fff",
                                      "&:hover": {
                                        backgroundColor: "#00384F",
                                      },
                                      width: 28,
                                      height: 28,
                                      borderRadius: "50%",
                                    }}
                                  >
                                    {iconMap[social]}
                                  </IconButton>
                                ))}
                              </Stack>
                            )}
                        </Box>
                      </Stack>
                      <CardContent
                        sx={{px: 0, paddingBottom: "0px", mb: 1}}
                        className={style.ourTeamText}
                      >
                        <Typography
                          className={style.truncateTwoLines}
                          variant="body2"
                          color="text.secondary"
                          mt={1}
                        >
                          {member.description_full}
                        </Typography>
                      </CardContent>

                      <Button
                        sx={{background: "#004F71"}}
                        variant="contained"
                        onClick={() => handleClickOpen(index + 1)}
                      >
                        {" "}
                        Read More
                      </Button>

                      {/* <div className={style.ourTeamHvr}>
                    <p>
                      {member.hover}
                    </p>
                  </div> */}
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Grid>
          </Grid>
        </Grid>
      </section>

      <Dialog
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{pb: 0}}>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={4} justifyContent="center">
              {teamMembers.map(
                (member, index) =>
                  member?.id === selectedMember && (
                    <Grid size={{xs: 12, md: 12}} key={index}>
                      <Card
                        sx={{borderRadius: 4}}
                        className={style.ourTeamBox + "team_modal_view"}
                        style={{boxShadow: "none", paddingBottom: "0px"}}
                      >
                        <Stack
                          spacing={2}
                          alignItems="center"
                          direction={{xs: "column", sm: "row"}}
                        >
                          <Avatar
                            variant="rounded"
                            alt={member.name}
                            src={member.image}
                            sx={{width: 150, height: 150}}
                          />
                          <Box>
                            <Typography variant="h6">{member.name}</Typography>
                            <Chip
                              label={member.title}
                              size="small"
                              sx={{
                                mt: 0.5,
                                backgroundColor: "#E5F3FA",
                                color: "#004F71",
                                fontWeight: 500,
                                fontSize: "0.75rem",
                                padding: "15px 10px",
                                marginBottom: "5px",
                              }}
                            />
                            <Stack
                              direction="row"
                              spacing={1}
                              mt={1}
                              className={style.TeamSocialIcon}
                            >
                              {Array.isArray(member.socials) &&
                                member.socials.length > 0 &&
                                member.socials.map((social) => (
                                  <IconButton
                                    aria-label="social-icon"
                                    key={social}
                                    className={style.ourTeamIcon}
                                    size="small"
                                    style={{padding: "17px"}}
                                    sx={{
                                      backgroundColor: "#004F71",
                                      color: "#fff",
                                      "&:hover": {
                                        backgroundColor: "#00384F", // darker on hover
                                      },
                                      width: 28,
                                      height: 28,
                                      borderRadius: "50%",
                                    }}
                                  >
                                    {iconMap[social]}
                                  </IconButton>
                                ))}
                            </Stack>
                          </Box>
                        </Stack>
                        <CardContent
                          sx={{px: 0, paddingBottom: "0px", mb: 2}}
                          className={style.ourTeamText}
                        >
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            mt={1}
                            sx={{textAlign: {xs: "center", sm: "left"}}}
                          >
                            {member.description_full}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AboutUs;
